/**
 * CheckLine / med.Visit.Stage: Reg=0, CheckIn=10, Triage=20, SeenDr=30, GivenMed=40, Payment=50, CheckOut=60, Cancel=99.
 * SeenDr (30+) is set when the doctor saves dispense — consult is finished; unpick/unclaim is no longer allowed.
 */
export function isConsultFinished(visitStage?: number | null): boolean {
  const stage = visitStage ?? 0;
  return stage >= 30 && stage !== 99;
}

/** CheckLine CCCS checkout — stage 60 with CCCS in remarks (corporate cancel / auto-close). */
export function isCccsCancelledVisit(remarks?: string | null): boolean {
  return Boolean(remarks?.toUpperCase().includes('CCCS'));
}

export function isCancelledVisit(visitStage?: number | null, remarks?: string | null): boolean {
  const stage = visitStage ?? 0;
  return stage === 99 || (stage >= 60 && isCccsCancelledVisit(remarks));
}

export function isCheckedOutVisit(visitStage?: number | null, remarks?: string | null): boolean {
  return (visitStage ?? 0) === 60 && !isCccsCancelledVisit(remarks);
}

/** True while a picked visit still blocks picking another patient (consult not yet saved). */
export function blocksDoctorPickAnotherPatient(visitStage?: number | null): boolean {
  const stage = visitStage ?? 0;
  return stage < 30 && stage !== 99;
}
